import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { i18n, initLocale } from '@/core/i18n'
import '@/core/theme/tokens.css'

import App from '@/app/app.vue'
import { router } from '@/app/router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)

// 감지된 언어 리소스를 먼저 받아온 뒤 마운트해야 첫 화면이 폴백 언어로 깜빡이지 않는다
initLocale().finally(() => {
  app.mount('#app')
})
